import React from "react";
import { Link } from "react-router-dom";

// FIAD brand lockup: authentic F-mark + FIAD wordmark.
// variant: "light" (white mark/text on dark) | "dark" (ink mark/text on light)
export default function Logo({ variant = "light", to = "/", className = "", testId = "logo" }) {
  const color = variant === "light" ? "text-[#F6F3EC]" : "text-[#0A0A0A]";
  const mark = variant === "light" ? "/fiad-mark-light.png" : "/fiad-mark-dark.png";
  const inner = (
    <span className={`inline-flex items-center gap-2 font-display font-semibold tracking-tight ${color} ${className}`}>
      <img src={mark} alt="FIAD" className="h-[1.55rem] w-auto self-center select-none" draggable="false" />
      <span className="inline-flex items-baseline gap-[3px]">
        <span className="text-[1.35rem] leading-none">FIAD</span>
        <span className="h-[5px] w-[5px] rounded-full self-end mb-[3px] bg-[#C79447]" aria-hidden />
      </span>
    </span>
  );
  if (!to) return inner;
  return (
    <Link to={to} data-testid={testId} aria-label="FIAD home">
      {inner}
    </Link>
  );
}
